export const fridays2025 = {
  label: "Fridays",
  key: "fridays",
  startDate: "2025-01-03",
  endDate: "2026-12-25",
  hourOfDonation: 14,
  interval: 7
};

export const dhul_hijjah_hijri_2026 = {
  label: "Dhul Hijjah Hijri 2026",
  key: "dhul_hijjah_hijri_2026",
  startDate: "2026-05-18",
  endDate: "2026-05-27",
  hourOfDonation: 22,
  interval: 1
};

export const dhul_hijjah_lunar_2026 = {
  label: "Dhul Hijjah Lunar 2026",
  key: "dhul_hijjah_lunar_2026",
  startDate: "2026-05-18",
  endDate: "2026-05-27",
  hourOfDonation: 22,
  interval: 1
};

// 2026 placeholders (dates will be set at conversion time for Ramadan pending flow)
export const ramadan_hijri_2026 = {
  label: "Ramadan Hijri 2026",
  key: "ramadan_hijri_2026",
  startDate: "2026-02-17",
  endDate: "2026-03-18",
  hourOfDonation: 22,
  interval: 1
};

export const ramadan_lunar_2026 = {
  label: "Ramadan Lunar 2026",
  key: "ramadan_lunar_2026",
  startDate: "2026-02-17",
  endDate: "2026-03-18",
  hourOfDonation: 22,
  interval: 1
};

export const ramadan_zakat_hijri_2026 = {
  label: "Ramadan Zakat Hijri 2026",
  key: "ramadan_zakat_hijri_2026",
  startDate: "2026-02-17",
  endDate: "2026-03-18",
  hourOfDonation: 22,
  interval: 1
};

export const ramadan_zakat_lunar_2026 = {
  label: "Ramadan Zakat Lunar 2026",
  key: "ramadan_zakat_lunar_2026",
  startDate: "2026-02-17",
  endDate: "2026-03-18",
  hourOfDonation: 22,
  interval: 1
};

// Supported 2026 campaign calendars plus Fridays
